import moment from 'moment';

export const parseDateAndTime = (date: string) => {
  moment.locale('pt-br');

  return (
    moment(new Date(date)).format('YYYY-MM-DDTHH:mm:00')
  );
}